import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
@charset "UTF-8";
:host {
  display: block;
  min-height: 100%;
}

.drone-dashboard {
  --bg: #0d1515;
  --surface: #121f1d;
  --surface-2: #172724;
  --surface-3: #1c302b;
  --line: rgba(123, 183, 160, .18);
  --text: #edf7f2;
  --muted: #8ca59d;
  --green: #45d39a;
  --blue: #3B82F6;
  --red: #EF4444;
  --amber: #f1b75d;
  min-height: 100vh;
  display: flex;
  overflow: hidden;
  background: var(--bg);
  color: var(--text);
  font-family: SUIT, sans-serif;
}

.dashboard-sidebar {
  width: 238px;
  flex: 0 0 238px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 25px 16px 18px;
  background: #101c1b;
  border-right: 1px solid var(--line);
}

.brand-lockup {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 0 9px 31px;
}

.brand-mark {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  color: #07130f;
  background: var(--green);
  border-radius: 10px;
  font-size: 16px;
}

.brand-copy {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}

.brand-copy strong {
  color: var(--text);
  letter-spacing: 0.14em;
  font-size: 13px;
}

.brand-copy span, .sidebar-label, .sidebar-footer {
  color: #688179;
  letter-spacing: 0.08em;
  font-size: 9px;
}

.sidebar-label {
  padding: 0 10px 9px;
  text-transform: uppercase;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sidebar-nav-item, .shortcut-item {
  border: 0;
  color: #91a7a0;
  background: transparent;
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.sidebar-nav-item {
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  font-size: 12px;
}

.sidebar-nav-item i {
  width: 16px;
  text-align: center;
  color: #69827a;
}

.sidebar-nav-item:hover {
  background: rgba(69, 211, 154, 0.07);
  color: var(--text);
}

.sidebar-nav-item.active {
  color: var(--green);
  background: rgba(69, 211, 154, 0.12);
}

.sidebar-nav-item.active i {
  color: var(--green);
}

.nav-live, .nav-count {
  margin-left: auto;
  font-size: 9px;
  letter-spacing: 0.08em;
}

.nav-live {
  padding: 3px 5px;
  color: var(--green);
  border: 1px solid rgba(69, 211, 154, 0.35);
  border-radius: 4px;
}

.nav-count {
  color: var(--red);
}

.sidebar-divider {
  height: 1px;
  margin: 24px 10px 20px;
  background: var(--line);
}

.sidebar-shortcuts {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.shortcut-item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 5px 10px;
  font-size: 11px;
}

.shortcut-item:hover {
  color: var(--text);
}

.shortcut-dot, .sync-dot {
  width: 6px;
  height: 6px;
  flex: 0 0 6px;
  border-radius: 50%;
  background: var(--blue);
}

.shortcut-dot.green, .sync-dot {
  background: var(--green);
  box-shadow: 0 0 0 3px rgba(69, 211, 154, 0.1);
}

.shortcut-dot.red {
  background: var(--red);
}

.sidebar-spacer {
  flex: 1;
}

.sidebar-status-card {
  margin: 22px 2px 18px;
  padding: 13px 12px;
  border: 1px solid var(--line);
  border-radius: 9px;
  background: rgba(69, 211, 154, 0.045);
}

.status-card-head {
  display: flex;
  align-items: center;
  gap: 7px;
  color: var(--muted);
  font-size: 10px;
}

.status-pulse {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--green);
  box-shadow: 0 0 0 4px rgba(69, 211, 154, 0.1);
}

.sidebar-status-card strong {
  display: block;
  margin: 10px 0 3px;
  color: var(--green);
  font-size: 12px;
}

.sidebar-status-card small {
  display: block;
  margin-bottom: 10px;
  color: #6d887f;
  font-size: 9px;
}

.demo-label {
  color: #75a996;
  font-size: 8px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  white-space: nowrap;
}

.demo-label.dark {
  color: #668a7c;
}

.sidebar-footer {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 0 8px;
}

.sidebar-footer-dot {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #4c6c60;
}

.dashboard-content {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.dashboard-topbar {
  min-height: 67px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 0 38px;
  border-bottom: 1px solid var(--line);
}

.topbar-context, .topbar-actions, .overview-meta, .hero-tools, .panel-actions, .panel-title-row, .stat-head, .stat-value-row, .frequency-card-top, .signal-row, .band-metrics, .chart-legend, .risk-row-label, .dashboard-footer {
  display: flex;
  align-items: center;
}

.topbar-context {
  gap: 11px;
  color: #718a82;
  font-size: 11px;
}

.eyebrow, .hero-kicker, .detail-overline {
  color: var(--green);
  font-size: 9px;
  letter-spacing: 0.15em;
  font-weight: 700;
}

.context-separator {
  color: #496159;
}

.topbar-actions {
  gap: 17px;
  color: #718b83;
  font-size: 10px;
}

.demo-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 10px;
  color: var(--green);
  border: 1px solid rgba(69, 211, 154, 0.28);
  background: rgba(69, 211, 154, 0.07);
  border-radius: 5px;
  font-size: 9px;
  letter-spacing: 0.04em;
}

.demo-pill i {
  font-size: 10px;
}

.topbar-time {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.icon-button {
  width: 32px;
  height: 32px;
  color: var(--muted);
  border: 1px solid var(--line);
  background: var(--surface);
  border-radius: 7px;
}

.mobile-menu-button {
  display: none;
}

.dashboard-scroll {
  flex: 1;
  overflow: auto;
  padding: 32px 38px 14px;
}

.dashboard-hero {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 28px;
  margin-bottom: 22px;
}

.hero-kicker {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  color: #6e9585;
}

.kicker-line {
  width: 21px;
  height: 1px;
  background: var(--green);
}

.hero-copy h1 {
  margin: 0;
  color: var(--text);
  font-size: clamp(24px, 3vw, 32px);
  font-weight: 700;
  letter-spacing: -0.045em;
}

.hero-copy p {
  margin: 9px 0 0;
  color: var(--muted);
  font-size: 13px;
}

.hero-tools {
  gap: 9px;
}

.search-box {
  position: relative;
  width: 270px;
}

.search-box > i {
  position: absolute;
  top: 12px;
  left: 13px;
  color: #638077;
  font-size: 12px;
}

.search-box input {
  box-sizing: border-box;
  width: 100%;
  height: 38px;
  padding: 0 36px;
  color: var(--text);
  outline: 0;
  border: 1px solid var(--line);
  background: var(--surface);
  border-radius: 7px;
  font: inherit;
  font-size: 11px;
}

.search-box input::placeholder {
  color: #698078;
}

.search-box input:focus {
  border-color: rgba(69, 211, 154, 0.7);
  box-shadow: 0 0 0 3px rgba(69, 211, 154, 0.08);
}

.search-shortcut {
  position: absolute;
  top: 9px;
  right: 10px;
  display: grid;
  place-items: center;
  width: 19px;
  height: 19px;
  color: #6a857b;
  border: 1px solid var(--line);
  border-radius: 4px;
  font-size: 11px;
}

.refresh-button, .outline-button, .detail-link, .text-action {
  border: 0;
  background: transparent;
  cursor: pointer;
  font: inherit;
}

.refresh-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 13px;
  color: #08140f;
  background: var(--green);
  border-radius: 7px;
  font-size: 11px;
  font-weight: 700;
}

.refresh-button:hover {
  background: #66e0ad;
}

.refresh-button i {
  font-size: 11px;
}

.overview-strip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 16px;
  padding: 15px 17px;
  border: 1px solid rgba(69, 211, 154, 0.27);
  background: linear-gradient(90deg, rgba(69, 211, 154, 0.09), rgba(69, 211, 154, 0.025));
  border-radius: 9px;
}

.overview-state {
  display: flex;
  align-items: center;
  gap: 12px;
}

.state-icon {
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  color: var(--green);
  border: 1px solid rgba(69, 211, 154, 0.25);
  background: rgba(69, 211, 154, 0.1);
  border-radius: 8px;
}

.state-label {
  display: block;
  color: #83a197;
  font-size: 10px;
}

.overview-state strong {
  display: inline-block;
  margin: 3px 8px 0 0;
  color: var(--green);
  font-size: 14px;
}

.overview-state small {
  color: #779087;
  font-size: 10px;
}

.overview-meta {
  gap: 13px;
}

.sync-status {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #7f9990;
  font-size: 10px;
}

.stats-grid, .skeleton-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.stat-card, .skeleton-card, .dashboard-panel {
  border: 1px solid var(--line);
  background: var(--surface);
  border-radius: 9px;
}

.stat-card {
  min-height: 108px;
  padding: 14px;
}

.stat-head {
  justify-content: space-between;
  gap: 8px;
}

.stat-label {
  color: #91a79f;
  font-size: 10px;
}

.stat-value-row {
  justify-content: space-between;
  margin-top: 11px;
}

.stat-value-row strong {
  color: var(--text);
  font-size: 25px;
  letter-spacing: -0.05em;
}

.stat-icon {
  display: grid;
  place-items: center;
  width: 29px;
  height: 29px;
  border-radius: 7px;
  font-size: 12px;
}

.tone-blue {
  color: var(--blue);
  background: rgba(59, 130, 246, 0.12);
}

.tone-green {
  color: var(--green);
  background: rgba(69, 211, 154, 0.12);
}

.tone-red {
  color: var(--red);
  background: rgba(239, 68, 68, 0.12);
}

.tone-amber {
  color: var(--amber);
  background: rgba(241, 183, 93, 0.12);
}

.stat-note {
  display: block;
  margin-top: 7px;
  color: #6f8a80;
  font-size: 9px;
}

.security-card {
  border-color: rgba(69, 211, 154, 0.27);
  background: linear-gradient(145deg, #142b25, var(--surface));
}

.skeleton-card {
  min-height: 108px;
  padding: 15px;
}

.skeleton-line {
  display: block;
  height: 10px;
  margin: 17px 0;
  background: #223733;
  border-radius: 4px;
  animation: pulse 1.3s infinite;
}

.skeleton-line.short {
  width: 45%;
  margin-top: 0;
}

.skeleton-line.value {
  width: 34%;
  height: 23px;
}

@keyframes pulse {
  50% {
    opacity: 0.45;
  }
}
.error-card {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
  padding: 22px;
  border: 1px solid rgba(239, 68, 68, 0.3);
  background: rgba(239, 68, 68, 0.07);
  border-radius: 9px;
}

.error-icon {
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  color: var(--red);
  background: rgba(239, 68, 68, 0.12);
  border-radius: 50%;
}

.error-card strong {
  font-size: 13px;
}

.error-card p {
  margin: 5px 0 0;
  color: var(--muted);
  font-size: 11px;
}

.error-card button {
  margin-left: auto;
  padding: 8px 11px;
  color: var(--text);
  border: 1px solid var(--line);
  background: var(--surface-2);
  border-radius: 6px;
  font-size: 10px;
}

.dashboard-panel {
  overflow: hidden;
}

.panel-heading {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 18px;
  padding: 18px 19px 15px;
  border-bottom: 1px solid rgba(123, 183, 160, 0.11);
}

.panel-heading.compact {
  padding-bottom: 14px;
}

.panel-title-row {
  gap: 9px;
}

.panel-heading h2 {
  margin: 0;
  color: var(--text);
  font-size: 14px;
  letter-spacing: -0.02em;
}

.panel-heading p {
  margin: 6px 0 0;
  color: #79928a;
  font-size: 10px;
}

.panel-actions {
  gap: 13px;
}

.filter-group, .period-filter {
  display: flex;
  padding: 3px;
  border: 1px solid var(--line);
  background: #0f1b1a;
  border-radius: 6px;
}

.filter-group button, .period-filter button {
  padding: 5px 8px;
  color: #789188;
  border: 0;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  font: inherit;
  font-size: 9px;
}

.filter-group button.selected, .period-filter button.selected {
  color: #07140f;
  background: var(--green);
  font-weight: 700;
}

.frequency-panel {
  margin-bottom: 18px;
}

.band-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 11px;
  padding: 17px 19px;
}

.frequency-card {
  position: relative;
  min-width: 0;
  padding: 13px;
  color: var(--text);
  text-align: left;
  border: 1px solid var(--line);
  background: var(--surface-2);
  border-radius: 8px;
  cursor: pointer;
  font: inherit;
}

.frequency-card:hover, .frequency-card.selected {
  border-color: rgba(69, 211, 154, 0.75);
  background: #1b302b;
}

.frequency-card.band-danger {
  border-color: rgba(239, 68, 68, 0.3);
}

.frequency-card.band-danger.selected {
  border-color: var(--red);
}

.frequency-card-top {
  justify-content: space-between;
  gap: 8px;
}

.frequency-name {
  display: block;
  color: var(--text);
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.frequency-role {
  display: block;
  margin-top: 3px;
  color: #6e8d82;
  font-size: 8px;
  letter-spacing: 0.12em;
}

.band-status, .detail-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 8px;
  white-space: nowrap;
}

.status-blue, .text-blue {
  color: var(--blue);
}

.status-green, .text-green {
  color: var(--green);
}

.status-amber, .text-amber {
  color: var(--amber);
}

.status-red, .text-red {
  color: var(--red);
}

.signal-row {
  justify-content: space-between;
  margin-top: 20px;
  color: #779189;
  font-size: 9px;
}

.signal-copy strong {
  margin-left: 8px;
  color: var(--text);
  font-size: 11px;
}

.signal-label {
  font-size: 9px;
}

.signal-meter, .risk-bar {
  overflow: hidden;
  height: 4px;
  margin-top: 8px;
  background: #0d1918;
  border-radius: 4px;
}

.signal-meter span, .risk-bar span {
  display: block;
  height: 100%;
  border-radius: inherit;
}

.fill-blue {
  background: var(--blue);
}

.fill-green {
  background: var(--green);
}

.fill-red {
  background: var(--red);
}

.fill-amber {
  background: var(--amber);
}

.band-sparkline {
  display: flex;
  align-items: flex-end;
  gap: 3px;
  height: 30px;
  margin-top: 14px;
  padding-bottom: 1px;
  border-bottom: 1px solid rgba(123, 183, 160, 0.1);
}

.band-sparkline span {
  flex: 1;
  min-height: 3px;
  opacity: 0.75;
  border-radius: 2px 2px 0 0;
}

.bar-blue {
  background: var(--blue);
}

.bar-green {
  background: var(--green);
}

.bar-red {
  background: var(--red);
}

.bar-amber {
  background: var(--amber);
}

.band-metrics {
  justify-content: space-between;
  gap: 5px;
  margin-top: 12px;
}

.band-metrics span {
  min-width: 0;
}

.band-metrics small, .band-metrics strong {
  display: block;
}

.band-metrics small {
  color: #668077;
  font-size: 8px;
}

.band-metrics strong {
  margin-top: 3px;
  color: #c7d9d2;
  font-size: 10px;
}

.card-arrow {
  position: absolute;
  right: 12px;
  bottom: 13px;
  color: #547267;
  font-size: 9px;
}

.empty-filter {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 30px;
  color: #78938a;
  font-size: 11px;
  text-align: center;
}

.empty-filter i {
  margin-bottom: 3px;
  color: var(--green);
  font-size: 18px;
}

.empty-filter strong {
  color: #c7d9d2;
}

.band-detail {
  display: flex;
  align-items: stretch;
  gap: 18px;
  margin: 0 19px 17px;
  padding: 14px 16px 14px 0;
  overflow: hidden;
  border: 1px solid rgba(69, 211, 154, 0.2);
  background: rgba(69, 211, 154, 0.04);
  border-radius: 7px;
}

.detail-accent {
  width: 3px;
  flex: 0 0 3px;
  border-radius: 0 4px 4px 0;
  background: var(--green);
}

.accent-blue {
  background: var(--blue);
}

.accent-amber {
  background: var(--amber);
}

.accent-red {
  background: var(--red);
}

.detail-main {
  flex: 1.7;
  min-width: 190px;
}

.detail-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.detail-heading strong {
  font-size: 17px;
}

.detail-overline {
  flex-basis: 100%;
  color: #6f9e8b;
}

.detail-main p {
  margin: 5px 0 0;
  color: #78938a;
  font-size: 10px;
}

.detail-stat {
  flex: 1;
  padding-left: 14px;
  border-left: 1px solid var(--line);
}

.detail-stat span, .detail-stat small {
  display: block;
  color: #78938a;
  font-size: 9px;
}

.detail-stat strong {
  display: block;
  margin: 5px 0 2px;
  color: var(--text);
  font-size: 14px;
}

.detail-link {
  align-self: center;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 0 7px 9px;
  color: var(--green);
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
}

.detail-link:hover, .text-action:hover {
  color: #a4e8cc;
}

.content-grid, .bottom-grid {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 18px;
  margin-bottom: 18px;
}

.anomaly-panel {
  grid-column: span 5;
}

.analysis-panel {
  grid-column: span 7;
}

.risk-panel {
  grid-column: span 7;
}

.personal-panel {
  grid-column: span 5;
}

.text-action {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding-top: 3px;
  color: var(--green);
  font-size: 10px;
  white-space: nowrap;
}

.event-list {
  padding: 4px 19px 0;
}

.event-row {
  display: grid;
  grid-template-columns: 53px 58px 1fr 12px;
  align-items: center;
  gap: 9px;
  width: 100%;
  padding: 12px 0;
  color: var(--text);
  text-align: left;
  border: 0;
  border-bottom: 1px solid rgba(123, 183, 160, 0.1);
  background: transparent;
  cursor: pointer;
  font: inherit;
}

.event-row:hover, .event-row.selected {
  background: rgba(69, 211, 154, 0.04);
}

.event-time {
  color: #718b82;
  font-family: monospace;
  font-size: 9px;
}

.severity-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: max-content;
  padding: 4px 5px;
  border-radius: 4px;
  font-size: 8px;
}

.severity-red {
  color: var(--red);
  background: rgba(239, 68, 68, 0.12);
}

.severity-amber {
  color: var(--amber);
  background: rgba(241, 183, 93, 0.12);
}

.severity-blue {
  color: var(--blue);
  background: rgba(59, 130, 246, 0.12);
}

.event-copy {
  min-width: 0;
}

.event-copy strong, .event-copy small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.event-copy strong {
  color: #dbe9e4;
  font-size: 10px;
}

.event-copy small {
  margin-top: 4px;
  color: #6e887f;
  font-size: 9px;
}

.event-chevron {
  color: #587267;
  font-size: 9px;
}

.event-inspector {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 13px 19px 17px;
  padding: 10px;
  border: 1px solid var(--line);
  background: #0f1b1a;
  border-radius: 6px;
}

.inspector-icon {
  display: grid;
  place-items: center;
  width: 27px;
  height: 27px;
  border-radius: 6px;
  font-size: 11px;
}

.inspector-copy {
  min-width: 0;
  flex: 1;
}

.inspector-copy span, .inspector-copy strong, .inspector-copy small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.inspector-copy span {
  color: #6f8b81;
  font-size: 8px;
}

.inspector-copy strong {
  margin: 3px 0;
  color: #d6e6df;
  font-size: 10px;
}

.inspector-copy small {
  color: #78938a;
  font-size: 9px;
}

.inspector-demo {
  align-self: flex-start;
  color: #55766a;
  font-size: 8px;
  letter-spacing: 0.08em;
}

.chart-legend {
  gap: 13px;
  padding: 13px 19px 0;
  color: #78928a;
  font-size: 9px;
}

.chart-legend span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.legend-dot, .risk-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.legend-dot.blue {
  background: var(--blue);
}

.legend-dot.red {
  background: var(--red);
}

.chart-range {
  margin-left: auto;
  color: #668077;
}

.line-chart {
  position: relative;
  display: flex;
  height: 230px;
  margin: 12px 19px 14px;
  padding: 0 8px 0 30px;
}

.chart-y-axis {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 5px 8px 24px 0;
  color: #607a70;
  font-size: 8px;
}

.chart-canvas {
  position: relative;
  flex: 1;
  min-width: 0;
}

.chart-canvas svg {
  position: absolute;
  inset: 0 0 24px;
  width: 100%;
  height: calc(100% - 24px);
  overflow: visible;
}

.chart-canvas line {
  stroke: rgba(123, 183, 160, 0.12);
  stroke-width: 1;
}

.chart-canvas polyline {
  fill: none;
  stroke: var(--blue);
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
  vector-effect: non-scaling-stroke;
}

.chart-canvas .anomaly-line {
  stroke: var(--red);
  stroke-width: 3;
}

.chart-canvas circle {
  fill: var(--red);
  stroke: #f8d0d0;
  stroke-width: 2;
}

.chart-alert-area {
  position: absolute;
  top: 0;
  bottom: 24px;
  left: 61%;
  right: 0;
  background: rgba(239, 68, 68, 0.055);
  border-left: 1px dashed rgba(239, 68, 68, 0.35);
  pointer-events: none;
}

.chart-alert-area span {
  position: absolute;
  top: 8px;
  right: 7px;
  color: rgba(239, 121, 121, 0.8);
  font-size: 8px;
}

.chart-x-axis {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  color: #607a70;
  font-family: monospace;
  font-size: 8px;
}

.chart-tooltip {
  position: absolute;
  top: 46px;
  right: 15%;
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 8px 9px;
  border: 1px solid rgba(239, 68, 68, 0.3);
  background: #182825;
  border-radius: 5px;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.18);
}

.chart-tooltip strong {
  color: #dceae5;
  font-family: monospace;
  font-size: 9px;
}

.chart-tooltip span {
  color: #c3d5ce;
  font-size: 9px;
}

.chart-tooltip small {
  color: #b07575;
  font-size: 8px;
}

.total-count {
  color: #78938a;
  font-size: 10px;
}

.total-count strong {
  color: var(--text);
  font-size: 15px;
}

.risk-summary {
  display: flex;
  align-items: center;
  gap: 28px;
  padding: 20px 22px 13px;
}

.risk-donut {
  display: grid;
  place-items: center;
  width: 106px;
  height: 106px;
  flex: 0 0 106px;
  background: conic-gradient(var(--red) 0 13%, var(--amber) 13% 38%, var(--blue) 38% 100%);
  border-radius: 50%;
}

.risk-donut > div {
  display: grid;
  place-items: center;
  width: 76px;
  height: 76px;
  background: var(--surface);
  border-radius: 50%;
}

.risk-donut strong {
  color: var(--text);
  font-size: 20px;
  line-height: 1;
}

.risk-donut span {
  color: #6f8b81;
  font-size: 8px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.risk-rows {
  flex: 1;
}

.risk-row {
  margin-bottom: 13px;
}

.risk-row:last-child {
  margin-bottom: 0;
}

.risk-row-label {
  gap: 7px;
  color: #a2b6ae;
  font-size: 10px;
}

.risk-row-label strong {
  margin-left: auto;
  color: #dbe9e4;
  font-size: 10px;
}

.dot-red {
  background: var(--red);
}

.dot-amber {
  background: var(--amber);
}

.dot-blue {
  background: var(--blue);
}

.risk-bar {
  height: 5px;
  margin-top: 7px;
}

.panel-footnote {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 11px 19px;
  color: #698178;
  border-top: 1px solid rgba(123, 183, 160, 0.1);
  font-size: 9px;
}

.panel-footnote i {
  color: var(--green);
}

.outline-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 9px;
  color: #a6bcb4;
  border: 1px solid var(--line);
  border-radius: 5px;
  font-size: 9px;
  white-space: nowrap;
}

.outline-button:hover {
  color: var(--green);
  border-color: rgba(69, 211, 154, 0.45);
}

.guest-callout {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 16px 19px 12px;
  padding: 10px;
  background: rgba(69, 211, 154, 0.045);
  border-radius: 6px;
}

.guest-icon {
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  color: var(--green);
  border: 1px solid rgba(69, 211, 154, 0.22);
  border-radius: 6px;
  font-size: 10px;
}

.guest-callout strong, .guest-callout span {
  display: block;
}

.guest-callout strong {
  color: #d7e8e1;
  font-size: 10px;
}

.guest-callout span {
  margin-top: 3px;
  color: #728d83;
  font-size: 9px;
}

.recent-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 7px;
  padding: 0 19px 18px;
}

.recent-item {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 8px 9px;
  color: #c3d7cf;
  border: 1px solid rgba(123, 183, 160, 0.13);
  background: #142320;
  border-radius: 5px;
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.recent-item:hover {
  border-color: rgba(69, 211, 154, 0.4);
}

.recent-item strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 10px;
}

.recent-item i {
  margin-left: auto;
  color: var(--green);
  font-size: 9px;
}

.recent-type {
  color: #6f8d82;
  font-size: 8px;
}

.dashboard-footer {
  justify-content: space-between;
  gap: 15px;
  padding: 6px 1px 16px;
  color: #607970;
  font-size: 9px;
}

.footer-warning {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.footer-warning i {
  color: #7ca797;
}

.footer-demo {
  color: #567267;
  font-family: monospace;
  font-size: 8px;
  letter-spacing: 0.08em;
  white-space: nowrap;
}

@media (max-width: 1180px) {
  .dashboard-sidebar {
    width: 210px;
    flex-basis: 210px;
  }
  .dashboard-topbar, .dashboard-scroll {
    padding-left: 26px;
    padding-right: 26px;
  }
  .stats-grid, .skeleton-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .band-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .security-card {
    grid-column: span 1;
  }
  .hero-tools {
    flex-direction: column;
    align-items: stretch;
  }
  .search-box {
    width: 245px;
  }
}
@media (max-width: 860px) {
  .drone-dashboard {
    display: block;
    overflow: auto;
  }
  .dashboard-sidebar {
    width: auto;
    min-height: 0;
    height: auto;
    padding: 15px 18px;
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }
  .brand-lockup {
    padding: 0 0 14px;
  }
  .sidebar-label, .sidebar-divider, .sidebar-shortcuts, .sidebar-status-card, .sidebar-footer, .sidebar-spacer {
    display: none;
  }
  .sidebar-nav {
    flex-direction: row;
    overflow-x: auto;
    gap: 5px;
  }
  .sidebar-nav-item {
    width: auto;
    flex: 0 0 auto;
    padding: 8px 10px;
  }
  .sidebar-nav-item span:not(.nav-live):not(.nav-count) {
    display: none;
  }
  .nav-live, .nav-count {
    margin-left: 0;
  }
  .dashboard-content {
    overflow: visible;
  }
  .dashboard-topbar {
    padding: 0 20px;
  }
  .dashboard-scroll {
    overflow: visible;
    padding: 25px 20px 12px;
  }
  .mobile-menu-button {
    display: block;
  }
  .content-grid, .bottom-grid {
    grid-template-columns: 1fr;
  }
  .anomaly-panel, .analysis-panel, .risk-panel, .personal-panel {
    grid-column: auto;
  }
  .dashboard-footer {
    align-items: flex-start;
    flex-direction: column;
  }
}
@media (max-width: 600px) {
  .dashboard-topbar {
    min-height: 58px;
    padding: 0 15px;
  }
  .topbar-context {
    font-size: 9px;
  }
  .topbar-time {
    display: none;
  }
  .demo-pill {
    padding: 6px 8px;
    font-size: 8px;
  }
  .dashboard-scroll {
    padding: 23px 15px 10px;
  }
  .dashboard-hero {
    display: block;
  }
  .hero-copy h1 {
    font-size: 25px;
  }
  .hero-copy p {
    line-height: 1.55;
  }
  .hero-tools {
    flex-direction: row;
    margin-top: 19px;
  }
  .search-box {
    width: auto;
    flex: 1;
  }
  .refresh-button {
    padding: 0 11px;
  }
  .refresh-button span {
    display: none;
  }
  .overview-strip {
    align-items: flex-start;
    flex-direction: column;
  }
  .overview-meta {
    width: 100%;
    justify-content: space-between;
    padding-left: 42px;
  }
  .stats-grid, .skeleton-grid, .band-grid {
    grid-template-columns: 1fr;
  }
  .panel-heading {
    gap: 12px;
    flex-direction: column;
  }
  .panel-actions {
    width: 100%;
    justify-content: flex-end;
  }
  .filter-group {
    width: 100%;
  }
  .filter-group button {
    flex: 1;
  }
  .band-detail {
    flex-wrap: wrap;
    gap: 12px;
  }
  .detail-main {
    flex-basis: calc(100% - 21px);
  }
  .detail-stat {
    flex: 1 1 28%;
    padding-left: 9px;
  }
  .detail-link {
    margin-left: auto;
  }
  .period-filter {
    max-width: 100%;
    overflow-x: auto;
  }
  .period-filter button {
    flex: 0 0 auto;
  }
  .line-chart {
    height: 210px;
    margin-left: 10px;
    margin-right: 10px;
  }
  .chart-tooltip {
    right: 2%;
  }
  .risk-summary {
    gap: 16px;
    padding-left: 17px;
    padding-right: 17px;
  }
  .risk-donut {
    width: 82px;
    height: 82px;
    flex-basis: 82px;
  }
  .risk-donut > div {
    width: 59px;
    height: 59px;
  }
  .risk-donut strong {
    font-size: 16px;
  }
  .recent-list {
    grid-template-columns: 1fr 1fr;
  }
  .footer-warning {
    align-items: flex-start;
    line-height: 1.5;
  }
}
.drone-dashboard.cover-mode {
  display: block;
  overflow: auto;
  background: #0b1514;
}

.welcome-cover {
  position: relative;
  min-height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  padding: 31px clamp(24px, 6vw, 92px) 22px;
  background: #0b1514;
  isolation: isolate;
}

.welcome-cover::before {
  position: absolute;
  z-index: -2;
  inset: -25% -10% 0 38%;
  content: "";
  background: radial-gradient(circle, rgba(56, 145, 111, 0.22) 0, rgba(21, 69, 55, 0.08) 28%, transparent 67%);
}

.welcome-cover::after {
  position: absolute;
  z-index: -1;
  inset: 0;
  content: "";
  opacity: 0.17;
  background-image: linear-gradient(rgba(109, 177, 151, 0.16) 1px, transparent 1px), linear-gradient(90deg, rgba(109, 177, 151, 0.16) 1px, transparent 1px);
  background-size: 56px 56px;
  mask-image: linear-gradient(to bottom, black, transparent 78%);
}

.welcome-topbar, .welcome-content, .welcome-points, .welcome-footer {
  position: relative;
  z-index: 1;
  max-width: 1280px;
  margin-right: auto;
  margin-left: auto;
}

.welcome-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.welcome-brand {
  display: inline-flex;
  align-items: center;
  gap: 11px;
  padding: 0;
  color: var(--text);
  border: 0;
  background: transparent;
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.welcome-brand-mark {
  display: grid;
  place-items: center;
  width: 37px;
  height: 37px;
  color: #06120e;
  background: var(--green);
  border-radius: 11px;
  box-shadow: 0 0 30px rgba(69, 211, 154, 0.22);
  font-size: 17px;
}

.welcome-brand-copy {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.welcome-brand-copy strong {
  color: var(--text);
  font-size: 13px;
  letter-spacing: 0.16em;
}

.welcome-brand-copy small, .welcome-time {
  color: #6f8c82;
  font-size: 9px;
  letter-spacing: 0.1em;
}

.welcome-top-meta {
  display: flex;
  align-items: center;
  gap: 18px;
}

.welcome-chip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 10px;
  color: var(--green);
  border: 1px solid rgba(69, 211, 154, 0.3);
  background: rgba(69, 211, 154, 0.07);
  border-radius: 5px;
  font-size: 9px;
  letter-spacing: 0.08em;
}

.welcome-chip i {
  font-size: 10px;
}

.welcome-content {
  display: grid;
  grid-template-columns: minmax(0, 0.92fr) minmax(390px, 0.88fr);
  align-items: center;
  gap: clamp(32px, 7vw, 110px);
  padding: clamp(58px, 9vh, 108px) 0 72px;
}

.welcome-copy {
  max-width: 615px;
}

.welcome-kicker {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 19px;
  color: #75a995;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.17em;
}

.welcome-kicker-line {
  width: 25px;
  height: 1px;
  background: var(--green);
}

.welcome-copy h1 {
  margin: 0;
  color: #f0f8f4;
  font-size: clamp(42px, 5.8vw, 72px);
  font-weight: 700;
  letter-spacing: -0.075em;
  line-height: 1.08;
}

.welcome-copy h1 em {
  color: var(--green);
  font-style: normal;
}

.welcome-copy > p {
  max-width: 540px;
  margin: 24px 0 0;
  color: #8da69d;
  font-size: 14px;
  line-height: 1.85;
}

.welcome-actions {
  display: flex;
  align-items: center;
  gap: 17px;
  margin-top: 31px;
}

.welcome-primary {
  display: inline-flex;
  align-items: center;
  gap: 18px;
  padding: 13px 15px 13px 18px;
  color: #07130f;
  border: 0;
  background: var(--green);
  border-radius: 7px;
  box-shadow: 0 10px 30px rgba(69, 211, 154, 0.12);
  cursor: pointer;
  font: inherit;
  font-size: 11px;
  font-weight: 700;
}

.welcome-primary:hover {
  background: #72e5b6;
  transform: translateY(-1px);
}

.welcome-primary i {
  font-size: 10px;
}

.welcome-action-note {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #6c877d;
  font-size: 10px;
}

.welcome-action-note i {
  color: #8bb5a5;
}

.welcome-trust {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 22px;
  margin-top: 39px;
  padding-top: 17px;
  border-top: 1px solid var(--line);
}

.welcome-trust div {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #719087;
  font-size: 9px;
}

.welcome-trust i {
  color: var(--green);
  font-size: 9px;
}

.welcome-visual-wrap {
  position: relative;
  width: min(100%, 520px);
  justify-self: end;
  padding: 21px 16px 18px;
}

.welcome-visual-glow {
  position: absolute;
  top: 8%;
  left: 6%;
  width: 82%;
  height: 82%;
  border-radius: 50%;
  background: rgba(69, 211, 154, 0.11);
  filter: blur(52px);
}

.radar-screen {
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(106, 171, 146, 0.32);
  background: rgba(15, 32, 29, 0.83);
  border-radius: 13px;
  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.27), inset 0 0 35px rgba(69, 211, 154, 0.035);
}

.radar-screen-head, .radar-screen-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 13px 16px;
  color: #719187;
  font-family: monospace;
  font-size: 8px;
  letter-spacing: 0.08em;
}

.radar-screen-head {
  border-bottom: 1px solid rgba(123, 183, 160, 0.13);
}

.radar-screen-head span:first-child, .radar-live, .radar-foot-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.radar-screen-head i, .radar-foot-status {
  color: var(--green);
}

.radar-live {
  color: #5c8676;
}

.radar-live span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--green);
  box-shadow: 0 0 0 4px rgba(69, 211, 154, 0.09);
}

.radar-body {
  position: relative;
  aspect-ratio: 1.12;
  overflow: hidden;
}

.radar-grid {
  position: absolute;
  inset: 9% 13%;
  opacity: 0.7;
  background: repeating-linear-gradient(0deg, transparent 0 29px, rgba(90, 157, 129, 0.13) 30px), repeating-linear-gradient(90deg, transparent 0 29px, rgba(90, 157, 129, 0.13) 30px);
  transform: perspective(220px) rotateX(2deg);
}

.radar-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  aspect-ratio: 1;
  border: 1px solid rgba(69, 211, 154, 0.24);
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.ring-one {
  width: 26%;
}

.ring-two {
  width: 51%;
}

.ring-three {
  width: 78%;
  border-color: rgba(69, 211, 154, 0.19);
}

.radar-cross {
  position: absolute;
  top: 50%;
  left: 13%;
  background: rgba(69, 211, 154, 0.17);
}

.cross-horizontal {
  width: 74%;
  height: 1px;
}

.cross-vertical {
  width: 1px;
  height: 82%;
  transform: translateY(-50%);
}

.radar-sweep {
  position: absolute;
  top: 11%;
  left: 13%;
  width: 74%;
  height: 78%;
  background: conic-gradient(from 270deg at 50% 50%, transparent 0 79%, rgba(69, 211, 154, 0.25) 86%, transparent 93%);
  animation: radar-sweep 5s linear infinite;
}

@keyframes radar-sweep {
  to {
    transform: rotate(360deg);
  }
}
.radar-point {
  position: absolute;
  width: 6px;
  height: 6px;
  background: var(--green);
  border-radius: 50%;
  box-shadow: 0 0 0 4px rgba(69, 211, 154, 0.13), 0 0 14px var(--green);
}

.point-one {
  top: 29%;
  left: 34%;
}

.point-two {
  top: 67%;
  left: 64%;
  background: var(--blue);
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.13), 0 0 14px var(--blue);
}

.point-three {
  top: 38%;
  left: 73%;
  background: var(--amber);
  box-shadow: 0 0 0 4px rgba(241, 183, 93, 0.13), 0 0 14px var(--amber);
}

.radar-core {
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 82px;
  height: 82px;
  color: var(--green);
  border: 1px solid rgba(69, 211, 154, 0.42);
  background: rgba(19, 48, 40, 0.85);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 32px rgba(69, 211, 154, 0.17);
}

.radar-core i {
  margin-bottom: 5px;
  font-size: 18px;
}

.radar-core strong {
  color: #d9eee5;
  font-size: 10px;
  letter-spacing: 0.08em;
}

.radar-core span {
  margin-top: 3px;
  color: #72ae94;
  font-family: monospace;
  font-size: 7px;
  letter-spacing: 0.12em;
}

.radar-axis {
  position: absolute;
  color: #5c8978;
  font-family: monospace;
  font-size: 8px;
}

.axis-top {
  top: 5%;
  left: 50%;
  transform: translateX(-50%);
}

.axis-right {
  top: 49%;
  right: 6%;
}

.axis-bottom {
  bottom: 5%;
  left: 50%;
  transform: translateX(-50%);
}

.axis-left {
  top: 49%;
  left: 6%;
}

.radar-screen-foot {
  border-top: 1px solid rgba(123, 183, 160, 0.13);
}

.radar-foot-status {
  color: var(--green);
}

.welcome-floating-card {
  position: absolute;
  display: flex;
  border: 1px solid rgba(113, 166, 145, 0.31);
  background: rgba(20, 41, 36, 0.94);
  border-radius: 8px;
  box-shadow: 0 13px 28px rgba(0, 0, 0, 0.2);
}

.signal-card {
  right: -13px;
  bottom: 28px;
  flex-direction: column;
  width: 119px;
  padding: 11px;
}

.event-card {
  top: 49px;
  left: -20px;
  align-items: center;
  gap: 8px;
  padding: 9px 11px;
}

.floating-label {
  color: #6e9182;
  font-size: 8px;
  letter-spacing: 0.08em;
}

.signal-card strong {
  margin-top: 6px;
  color: var(--green);
  font-size: 12px;
}

.signal-card small, .event-card small {
  color: #78948a;
  font-size: 8px;
}

.floating-meter {
  height: 4px;
  margin: 9px 0 6px;
  overflow: hidden;
  background: #0b1715;
  border-radius: 4px;
}

.floating-meter span {
  display: block;
  width: 86%;
  height: 100%;
  background: var(--green);
  border-radius: inherit;
}

.floating-icon {
  display: grid;
  place-items: center;
  width: 27px;
  height: 27px;
  color: var(--green);
  background: rgba(69, 211, 154, 0.1);
  border-radius: 6px;
}

.event-card strong {
  display: block;
  color: #dcebe5;
  font-size: 9px;
}

.welcome-points {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  padding-top: 18px;
  border-top: 1px solid var(--line);
}

.welcome-point {
  display: grid;
  grid-template-columns: 25px 31px 1fr;
  align-items: start;
  gap: 10px;
  min-width: 0;
  padding: 6px 12px 7px 0;
}

.point-index {
  color: #52776a;
  font-family: monospace;
  font-size: 9px;
}

.point-icon {
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  color: var(--green);
  background: rgba(69, 211, 154, 0.08);
  border-radius: 7px;
  font-size: 11px;
}

.welcome-point strong {
  display: block;
  margin-top: 1px;
  color: #d7e7e1;
  font-size: 11px;
}

.welcome-point p {
  margin: 5px 0 0;
  color: #6d887e;
  font-size: 9px;
  line-height: 1.6;
}

.welcome-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding-top: 23px;
  color: #607b70;
  font-size: 9px;
}

.welcome-footer span:first-child {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.welcome-footer i {
  color: #7fae9b;
}

.welcome-footer-demo {
  color: #527569;
  font-family: monospace;
  font-size: 8px;
  letter-spacing: 0.08em;
}

@media (max-width: 950px) {
  .welcome-cover {
    padding-right: 26px;
    padding-left: 26px;
  }
  .welcome-content {
    grid-template-columns: minmax(0, 1fr) minmax(300px, 0.8fr);
    gap: 30px;
  }
  .welcome-copy h1 {
    font-size: clamp(38px, 6vw, 58px);
  }
  .event-card {
    left: -8px;
  }
  .signal-card {
    right: -4px;
  }
}
@media (max-width: 720px) {
  .welcome-cover {
    padding: 22px 18px 18px;
  }
  .welcome-top-meta {
    gap: 0;
  }
  .welcome-time {
    display: none;
  }
  .welcome-chip {
    padding: 6px 8px;
    font-size: 8px;
  }
  .welcome-content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 62px 0 55px;
  }
  .welcome-copy {
    max-width: none;
  }
  .welcome-copy h1 {
    font-size: clamp(38px, 11vw, 54px);
  }
  .welcome-copy > p {
    margin-top: 18px;
    font-size: 12px;
  }
  .welcome-actions {
    align-items: flex-start;
    flex-direction: column;
    gap: 13px;
    margin-top: 24px;
  }
  .welcome-trust {
    margin-top: 26px;
  }
  .welcome-visual-wrap {
    align-self: center;
    width: min(100%, 520px);
    padding-top: 15px;
  }
  .welcome-points {
    grid-template-columns: 1fr;
    gap: 5px;
  }
  .welcome-point {
    grid-template-columns: 25px 31px 1fr;
    padding-top: 9px;
    padding-bottom: 9px;
  }
  .welcome-footer {
    align-items: flex-start;
    flex-direction: column;
    padding-top: 19px;
    line-height: 1.5;
  }
  .welcome-footer-demo {
    align-self: flex-start;
  }
}
@media (max-width: 420px) {
  .welcome-brand-copy strong {
    font-size: 11px;
  }
  .welcome-brand-copy small {
    font-size: 8px;
  }
  .welcome-chip {
    font-size: 7px;
    letter-spacing: 0.04em;
  }
  .welcome-visual-wrap {
    padding-right: 4px;
    padding-left: 4px;
  }
  .welcome-floating-card {
    transform: scale(0.88);
  }
  .event-card {
    left: -18px;
  }
  .signal-card {
    right: -16px;
  }
}
/* 요청 문구 전용: 기존 제목 크기의 약 2/3 */
.welcome-copy h1.welcome-heading {
  font-size: clamp(28px, 3.87vw, 48px);
}

@media (max-width: 950px) {
  .welcome-copy h1.welcome-heading {
    font-size: clamp(25px, 4vw, 39px);
  }
}
@media (max-width: 720px) {
  .welcome-copy h1.welcome-heading {
    font-size: clamp(25px, 7.33vw, 36px);
  }
}
/* Interactive attacker-signal detection */
.radar-screen,
.radar-ring,
.radar-cross,
.radar-core,
.welcome-visual-glow,
.welcome-floating-card,
.floating-icon,
.floating-meter span {
  transition: color 0.25s ease, border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease, opacity 0.25s ease;
}

.radar-body {
  width: 100%;
  color: inherit;
  outline: 0;
  cursor: crosshair;
  user-select: none;
  touch-action: manipulation;
}

.radar-body:focus-visible {
  box-shadow: inset 0 0 0 2px rgba(69, 211, 154, 0.72);
}

.radar-status-announcement {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.attacker-signal {
  position: absolute;
  z-index: 5;
  width: 14px;
  height: 14px;
  border: 2px solid #ff98a0;
  background: var(--red);
  border-radius: 50%;
  box-shadow: 0 0 0 5px rgba(239, 68, 68, 0.18), 0 0 24px rgba(239, 68, 68, 0.95);
  transform: translate(-50%, -50%);
  pointer-events: none;
  animation: attacker-core-pulse 0.55s ease-in-out infinite alternate;
}

.attacker-signal::before,
.attacker-signal::after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 26px;
  height: 26px;
  content: "";
  border: 1px solid rgba(239, 68, 68, 0.95);
  border-radius: 50%;
  transform: translate(-50%, -50%) scale(0.45);
  animation: attacker-ring 1.25s ease-out infinite;
}

.attacker-signal::after {
  animation-delay: 0.62s;
}

.attacker-signal-label {
  position: absolute;
  top: 21px;
  left: 50%;
  padding: 4px 6px;
  color: #ffd5d8;
  border: 1px solid rgba(239, 68, 68, 0.45);
  background: rgba(72, 15, 20, 0.92);
  border-radius: 4px;
  font-family: monospace;
  font-size: 7px;
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: 1;
  white-space: nowrap;
  transform: translateX(-50%);
}

@keyframes attacker-core-pulse {
  to {
    box-shadow: 0 0 0 7px rgba(239, 68, 68, 0.23), 0 0 32px rgb(239, 68, 68);
  }
}
@keyframes attacker-ring {
  0% {
    opacity: 0.9;
    transform: translate(-50%, -50%) scale(0.45);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(2.7);
  }
}
@keyframes threat-status-pulse {
  50% {
    opacity: 0.42;
    box-shadow: 0 0 0 7px rgba(239, 68, 68, 0.12), 0 0 16px rgba(239, 68, 68, 0.65);
  }
}
@keyframes threat-panel-pulse {
  50% {
    box-shadow: 0 13px 32px rgba(239, 68, 68, 0.15);
  }
}
.threat-detected .welcome-visual-glow {
  background: rgba(239, 68, 68, 0.13);
}

.threat-detected .radar-screen {
  border-color: rgba(239, 68, 68, 0.62);
  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.3), inset 0 0 42px rgba(239, 68, 68, 0.09);
}

.threat-detected .radar-screen-head {
  border-bottom-color: rgba(239, 68, 68, 0.25);
}

.threat-detected .radar-screen-foot {
  border-top-color: rgba(239, 68, 68, 0.25);
}

.threat-detected .radar-screen-head i,
.threat-detected .radar-live,
.threat-detected .radar-foot-status,
.threat-detected .radar-screen-foot > span:first-child {
  color: #ff7a82;
}

.threat-detected .radar-live span {
  background: var(--red);
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.13);
  animation: threat-status-pulse 0.8s ease-in-out infinite;
}

.threat-detected .radar-ring {
  border-color: rgba(239, 68, 68, 0.3);
}

.threat-detected .radar-cross {
  background: rgba(239, 68, 68, 0.23);
}

.threat-detected .radar-sweep {
  background: conic-gradient(from 270deg at 50% 50%, transparent 0 75%, rgba(239, 68, 68, 0.36) 86%, transparent 94%);
  animation-duration: 1.45s;
}

.threat-detected .radar-core {
  color: #ff717a;
  border-color: rgba(239, 68, 68, 0.65);
  background: rgba(68, 22, 24, 0.9);
  box-shadow: 0 0 38px rgba(239, 68, 68, 0.25);
  animation: threat-panel-pulse 0.85s ease-in-out infinite;
}

.threat-detected .radar-core span {
  color: #ff9299;
}

.threat-detected .signal-card,
.threat-detected .event-card {
  border-color: rgba(239, 68, 68, 0.48);
  background: rgba(58, 25, 27, 0.96);
  animation: threat-panel-pulse 1.1s ease-in-out infinite;
}

.threat-detected .floating-label,
.threat-detected .signal-card strong {
  color: #ff7a82;
}

.threat-detected .floating-icon {
  color: #ff7a82;
  background: rgba(239, 68, 68, 0.13);
}

.threat-detected .floating-meter span {
  width: 100%;
  background: var(--red);
  animation: threat-status-pulse 0.8s ease-in-out infinite;
}

@media (hover: hover) and (pointer: fine) {
  .radar-screen:hover {
    border-color: rgba(69, 211, 154, 0.56);
    box-shadow: 0 28px 74px rgba(0, 0, 0, 0.3), inset 0 0 40px rgba(69, 211, 154, 0.06);
  }
  .threat-detected .radar-screen:hover {
    border-color: rgba(239, 68, 68, 0.78);
  }
}
@media (prefers-reduced-motion: reduce) {
  .radar-sweep,
  .attacker-signal,
  .attacker-signal::before,
  .attacker-signal::after,
  .threat-detected .radar-live span,
  .threat-detected .radar-core,
  .threat-detected .signal-card,
  .threat-detected .event-card,
  .threat-detected .floating-meter span {
    animation: none;
  }
  .attacker-signal::before,
  .attacker-signal::after {
    opacity: 0.5;
    transform: translate(-50%, -50%) scale(1.8);
  }
}`],
})
export class PageAccessComponent implements OnInit, OnDestroy {
    public threatDetected = false;
    public threatSeconds = 0;
    public threatX = 70;
    public threatY = 34;

    private threatTimerId?: number;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public ngOnDestroy() {
        this.clearThreatTimer();
    }

    public detectThreat(event: MouseEvent): void {
        const radar = event.currentTarget as HTMLElement;
        const bounds = radar.getBoundingClientRect();

        this.threatX = this.clamp(((event.clientX - bounds.left) / bounds.width) * 100, 18, 82);
        this.threatY = this.clamp(((event.clientY - bounds.top) / bounds.height) * 100, 18, 78);
        this.startThreatDetection();
    }

    public detectThreatFromKeyboard(): void {
        this.threatX = 70;
        this.threatY = 34;
        this.startThreatDetection();
    }

    private startThreatDetection(): void {
        this.clearThreatTimer();
        this.threatDetected = true;
        this.threatSeconds = 5;

        this.threatTimerId = window.setInterval(() => {
            this.threatSeconds -= 1;

            if (this.threatSeconds <= 0) {
                this.clearThreatTimer();
                this.threatDetected = false;
                this.threatSeconds = 0;
            }
        }, 1000);
    }

    private clearThreatTimer(): void {
        if (this.threatTimerId !== undefined) {
            window.clearInterval(this.threatTimerId);
            this.threatTimerId = undefined;
        }
    }

    private clamp(value: number, min: number, max: number): number {
        return Math.min(max, Math.max(min, value));
    }
}

export default PageAccessComponent;